
import { useCollection, useUser, useMemoFirebase, useFirestore } from '@/firebase';
import { collection, query, orderBy } from 'firebase/firestore';
import { Button } from '@/components/ui/button';
import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Itinerary } from '@/app/lib/types';
import { ItineraryListSkeleton } from '@/components/itinerary/dashboard/ItineraryListSkeleton';
import { ItineraryListItem } from '@/components/itinerary/dashboard/ItineraryListItem';
import { NoItineraries } from '@/components/itinerary/dashboard/NoItineraries';


export default function ItineraryDashboardPage() {
  const { user, isUserLoading } = useUser();
  const firestore = useFirestore();

  const itinerariesQuery = useMemoFirebase(() => {
    if (!firestore || !user) return null;
    return query(
      collection(firestore, 'users', user.uid, 'itineraries'),
      orderBy('startDate', 'desc')
    );
  }, [firestore, user]);

  const { data: itineraries, isLoading } = useCollection<Itinerary>(itinerariesQuery);

  const showLoading = isUserLoading || isLoading;


  return (
    <div className="container mx-auto">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 sm:mb-6 md:mb-8 gap-3 sm:gap-4">
        <div>
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight">My Expeditions</h1>
            <p className="text-sm sm:text-base text-muted-foreground mt-1 sm:mt-2">Here are all the wild swimming adventures you've saved.</p>
        </div>
        <Button asChild className="w-full sm:w-auto text-sm">
            <Link to="/itinerary/discover">
                <Compass className="mr-2 h-4 w-4" />
                Discover Routes
            </Link>
        </Button>
      </div>

      {showLoading && <ItineraryListSkeleton />}

      {!showLoading && itineraries && itineraries.length > 0 && (
         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
            {itineraries.map((itinerary) => (
                <ItineraryListItem key={itinerary.id} itinerary={itinerary} />
            ))}
        </div>
      )}

      {!showLoading && itineraries && itineraries.length === 0 && <NoItineraries />}

    </div>
  );
}
